/* eslint-disable import/prefer-default-export */
export const Attendance = {
  ABSENT: 'absent',
  LATE: 'late',
  LEFT_EARLY: 'leftEarly',
  NCNS: 'ncns',
  PRESENT: 'present',
};
